import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { X } from 'lucide-react';

export default function PaymentCancelled() {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <div className="noise-overlay" />
      
      <div className="max-w-md w-full text-center">
        <Link to="/" className="font-heading text-2xl font-bold text-[#C9A84C] inline-block mb-8">
          SAC CITY SHINE
        </Link>

        <div className="bg-surface border border-[#262626] p-8" data-testid="payment-cancelled">
          <div className="w-20 h-20 bg-gray-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <X className="h-10 w-10 text-white" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-white mb-4">
            Payment Cancelled
          </h1>
          <p className="text-gray-400 mb-6">
            Your payment was cancelled. Your booking is still pending and you can pay the deposit later using the link in your email.
          </p>
          <div className="bg-surface-highlight border border-[#262626] p-4 mb-6">
            <p className="text-white font-medium">Need Help?</p>
            <p className="text-gray-400 text-sm mt-2">
              If you're having issues with payment, please contact us and we'll help you complete your booking.
            </p>
          </div>
          <div className="flex gap-4 justify-center">
            <Link to="/">
              <Button variant="outline" className="border-[#262626] text-white hover:bg-surface-highlight rounded-sm">
                Go Home
              </Button>
            </Link>
            <Link to="/booking">
              <Button className="bg-white text-black hover:bg-gray-200 rounded-sm">
                Book Again
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
